// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1g7ST","left":"InfoRow_left__3YZOh"};